import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query'
import { reviewTemplateKeys } from './reviewTemplateKeys'

export interface UseDeleteReviewTemplateProps extends UseMutationOptions<{}, unknown, number> {
  workspaceId: number
}

export const useDeleteReviewTemplate = ({ workspaceId, ...options }: UseDeleteReviewTemplateProps) => {
  const client = useQueryClient()
  const onSuccess = (result: {}, templateId: number, context: unknown) => {
    client.invalidateQueries(reviewTemplateKeys.list(workspaceId))
    options.onSuccess?.(result, templateId, context)
  }
  return useMutation<{}, unknown, number>(
    async (templateId: number) => {
      const res = await sendToApi<{}>(`/w/${workspaceId}/review_templates/${templateId}`, {
        method: 'DELETE',
      })
      if (res.type !== SUCCESS_RESPONSE_TYPE) throw new Error()
      return res.data
    },
    { ...options, onSuccess },
  )
}
